import React from 'react';

export default function DescriptionSplit({
    description,
    theme = "dark",
    text = "justify",
    className = ""
}) {
    return (
        <div
            className={[
                "text-sm md:text-base",
                theme === "dark" ? "text-description" : "text-white",
                text === "justify" ? "text-justify" : "text-center",
                "opacity-60",
                className
            ].join(" ")}
        >
            {/* On laisse le HTML intact pour garder les <strong>, <p>, etc. */}
            <div
                dangerouslySetInnerHTML={{ __html: description }}
            />
        </div>
    );
}